/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createJobAcceptedResponseFromDiscriminatorValue, serializeImageTrashPurgeJobRequest, serializeJobAcceptedResponse, type ErrorResponse, type ImageTrashPurgeJobRequest, type InternalErrorResponse, type JobAcceptedResponse } from '../../../models/index.js';
// @ts-ignore
import { ProgressRequestBuilderNavigationMetadata, type ProgressRequestBuilder } from './progress/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/jobs/image-trash-purge
 */
export interface ImageTrashPurgeRequestBuilder extends BaseRequestBuilder<ImageTrashPurgeRequestBuilder> {
    /**
     * The progress property
     */
    get progress(): ProgressRequestBuilder;
    /**
     * Deleted images sit in a trash - removed from the platform but kept in storage - and stay recoverable. This job lists the trash and, unless dryRun is true (the default), permanently purges assets trashed longer ago than the retention window. The purge is queued and this returns immediately with a tracking id; poll the returned status URI for the findings.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<JobAcceptedResponse>}
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: ImageTrashPurgeJobRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<JobAcceptedResponse | undefined>;
    /**
     * Deleted images sit in a trash - removed from the platform but kept in storage - and stay recoverable. This job lists the trash and, unless dryRun is true (the default), permanently purges assets trashed longer ago than the retention window. The purge is queued and this returns immediately with a tracking id; poll the returned status URI for the findings.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: ImageTrashPurgeJobRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const ImageTrashPurgeRequestBuilderUriTemplate = "{+baseurl}/api/jobs/image-trash-purge";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const ImageTrashPurgeRequestBuilderNavigationMetadata: Record<Exclude<keyof ImageTrashPurgeRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    progress: {
        navigationMetadata: ProgressRequestBuilderNavigationMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const ImageTrashPurgeRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: ImageTrashPurgeRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createJobAcceptedResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeImageTrashPurgeJobRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
